<template>
  <div>
    <nav class="nav-account">
      <a
        v-for="tab in filteredTabs"
        :key="tab"
        :class="currentTab == tab ? 'nav-account__item active' : 'nav-account__item'"
        @click="changeTab(tab)"
      >
        {{ $t(`admins.tabs.${tab}`) }}
      </a>
    </nav>
    <AdminEditForm
      v-if="currentTab === 'edit' && selectedAdmin"
      action="edit"
      @save="save"
    ></AdminEditForm>
    <AdminNotifications v-else-if="currentTab === 'notifications'"></AdminNotifications>
    <AdminGroups v-else-if="currentTab === 'groups'"></AdminGroups>
  </div>
</template>

<script>
import AdminEditForm from './AdminEditForm.vue';
import AdminNotifications from './AdminNotifications.vue';
import AdminGroups from './AdminGroups.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'AdminEditPage',
  components: {
    AdminEditForm,
    AdminNotifications,
    AdminGroups
  },
  data() {
    return {
      tabs: ['edit', 'groups', 'notifications'],
      currentTab: 'edit',
      selectedAdmin: null
    };
  },
  computed: {
    ...mapGetters(['isExpert']),
    filteredTabs() {
      if (this.isExpert) {
        return this.tabs.filter((tab) => tab !== 'groups');
      }
      return this.tabs;
    }
  },
  async created() {
    const adminId = this.$route.params.id;
    this.selectedAdmin = await this.getAdminData(adminId); // TODO: VUEX has logic coupled.
  },
  methods: {
    ...mapActions(['updateAdmin', 'getAdminData']),
    ...mapMutations(['SET_ADMIN']),

    save(admin) {
      const info = {
        admin,
        notification: {
          type: 'success',
          message: `feedback.success.updateClient`,
          show: true
        }
      };
      const adminData = this.updateAdmin(info);
      setTimeout(() => {
        if (adminData) {
          this.$router.push({ name: 'admins' });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 2000);
    },
    changeTab(tab) {
      this.currentTab = tab;
    }
  }
};
</script>
